/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { Fragment } from 'react';

import { socialMediaAnalytics } from '../../analyticsConsts';
import { EMPTY_STRING, ICONS_MEDIA } from '../../const';
import useClubDetailsStyle from '../ClubDetails/styles';
import useClubDetailsContactDetailsStyle from '../ClubDetailsContactDetails/styles';
import ExternalLink from '../ExternalLink';
import useStyles from './styles';

const { SOCIAL_MEDIA_WRAPPER, SOCIAL_MEDIA_CTA } = socialMediaAnalytics;

const SocialMedia = ({ title, socialLinks, isClubDetailPage }) => {
  const styles = useStyles();
  const stylesClubDetails = useClubDetailsStyle();
  const stylesClubDetailsContactDetails = useClubDetailsContactDetailsStyle();

  return (
    <Fragment>
      {socialLinks?.isPublic && !isClubDetailPage && (
        <div css={styles.footer} id={SOCIAL_MEDIA_WRAPPER}>
          <div css={styles.footerWrapper}>
            <ul css={styles.list}>
              <li>{title} social media</li>
              {socialLinks &&
                socialLinks.socialMediaLinks.length > 0 &&
                socialLinks.socialMediaLinks.slice(0, 3).map(link => {
                  const SocialMediaIcon = ICONS_MEDIA[link.mediaType];
                  return (
                    <li key={link.mediaTypeId}>
                      <ExternalLink
                        id={`${SOCIAL_MEDIA_CTA}_${link.mediaTypeId}`}
                        css={styles.link}
                        className={link.className}
                        href={
                          link.prefixUrl +
                          `${link.mediaLink ? link.mediaLink : EMPTY_STRING}`
                        }
                      >
                        <SocialMediaIcon />
                      </ExternalLink>
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      )}
      {socialLinks?.isPublic && isClubDetailPage && (
        <div css={stylesClubDetails.group}>
          <div css={stylesClubDetails.groupLabel}>Social Media</div>
          <div css={stylesClubDetails.groupValue}>
            {socialLinks &&
              socialLinks.socialMediaLinks.length > 0 &&
              socialLinks.socialMediaLinks.slice(0, 3).map((link, index) => {
                return (
                  <Fragment key={index}>
                    <ExternalLink
                      id={`${SOCIAL_MEDIA_CTA}_${link.mediaTypeId}`}
                      css={stylesClubDetailsContactDetails.link}
                      className={link.className}
                      href={
                        link.prefixUrl +
                        `${link.mediaLink ? link.mediaLink : EMPTY_STRING}`
                      }
                    >
                      {link.mediaType}
                    </ExternalLink>
                    {index < socialLinks.socialMediaLinks.slice(0, 3).length - 1
                      ? ` | `
                      : ''}
                  </Fragment>
                );
              })}
          </div>
        </div>
      )}
    </Fragment>
  );
};

SocialMedia.propTypes = {
  title: PropTypes.string,
  socialLinks: PropTypes.object,
  isClubDetailPage: PropTypes.bool,
};

export default SocialMedia;
